<template>
  <div class="register">
    <div class="content">
      <div class="head">
        请输入服务点代码
      </div>
      <div class="body">
        <input class="form-control input-lg" type="text" @keyup.enter="setCode" v-model="code">
        <p class="tip" style="color:red">{{ errcode }}</p>
      </div>
      <div class="foot">
        <a class="lp-btn large primary" @click="setCode">确定</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      code: '',
      errcode: '',
    }
  },
  methods: {
    async getPosition (code) {
      if (!code) {
        this.$message.error = '请输入服务点代码'
        return
      }
      const result = await this.$api.getMachineInfo({ no: code })
      if (result) {
        localStorage.code = code
      }
      await this.$store.dispatch('device/getData')
      this.$router.push('/')
    },
    setCode () {
      this.getPosition(this.code.trim())
    }
  }
}
</script>
<style lang="stylus" scoped>
.register
  width 100%
  height 100vh
  background rgba(0, 0, 0, 0.5)
  .content
    width 11rem
    background #fff
    border-radius 0.1rem
    padding 0.35rem 0.15rem
    margin 1rem auto 0
    position absolute
    top 1rem
    left 50%
    transform translateX(-50%)
    z-index 100
    .head
      position relative
      font-size 0.36rem
      text-align center
      padding 0.15rem
    .body
      padding 0.2rem 0.6rem
      font-size 0.2rem
    .foot
      display flex
      align-items center
      justify-content center
      padding 0.15rem
      .lp-btn.large
        width 2.8rem
        text-align center
        height 0.72rem
        line-height 0.72rem
        font-size 0.28rem
      .lp-btn.primary
        color #fff
        background #3d69bd
</style>
